<template>
  <div class="chatbot-container">
    <!--<div class="modal-content floating-window p-3" id="draggableWindow">
      <div class="modal-header">
        <h5 class="modal-title">Draggable Floating Window</h5>
        <button type="button" class="btn-close" id="closeFloatingWindow"></button>
      </div>
      <div class="modal-body">
        This is a draggable floating window.
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" id="closeFloatingWindowFooter">Close</button>
      </div>
    </div>-->
    <b-row>
      <b-col>
        <div class="chatbot-buttons">
          <div class="chatbot-buttons-l">
            <b-btn @click="newChat"><i class="fa fa-pen"></i> New Chat</b-btn>
            <b-btn @click="deleteIndexing"><i class="fa fa-trash"></i> Delete</b-btn>
          </div>
          <div class="chatbot-buttons-r">
            <!--<b-btn v-if="layout === 'full'" @click="floatingView"><i class="fa fa-window-restore" /></b-btn>
            <b-btn v-else @click="fullView"><i class="fa fa-window-maximize" /></b-btn>
            <b-btn @click="close"><i class="fa fa-sliders-h" /></b-btn>-->
            <b-btn @click="close"><i class="fa fa-times" /></b-btn>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-alert variant="danger" class="d-flex alerts" :show="showConfirmDelete"
          >Warning: You will have to start MyndSparks again, which may consume extra time
          <b-btn
            size="sm"
            class="p-1 ml-auto"
            variant="outline-secondary"
            @click="toggleConfirmDelete()"
            >Cancel</b-btn
          >
          &nbsp;&nbsp;&nbsp;
          <b-btn
            size="sm"
            class="p-1"
            variant="outline-secondary"
            @click="deleteIndexing()"
            >Confirm Delete</b-btn
          >
        </b-alert>
        <!--<b-alert variant="warning" class="d-flex alerts" :show="showConfirmNew"
          >Warning: You will loose current conversation. Please save it if necessary!
          <b-btn
            size="sm"
            class="p-1 ml-auto"
            variant="outline-secondary"
            @click="toggleConfirmNew()"
            >Cancel</b-btn
          >
          &nbsp;&nbsp;&nbsp;
          <b-btn
            size="sm"
            class="p-1"
            variant="outline-secondary"
            @click="newChat()"
            >Start New</b-btn
          >
        </b-alert>-->
        <b-alert variant="warning" class="d-flex alerts" :show="showConfirmClear"
          >Warning: You are about leave this page and loose your history. Please save if you intend to keep it.
          <b-btn
            size="sm"
            class="p-1 ml-auto"
            variant="outline-secondary"
            @click="toggleConfirmClear()"
            >Cancel</b-btn
          >
          &nbsp;&nbsp;&nbsp;
          <b-btn
            size="sm"
            class="p-1"
            variant="outline-secondary"
            @click="close()"
            >Close Without Saving</b-btn
          >
          &nbsp;&nbsp;&nbsp;
          <b-btn
            size="sm"
            class="p-1"
            variant="outline-secondary"
            @click="saveAndclose()"
            >Save &amp; Close</b-btn
          >
        </b-alert>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="3" class="threads-col">
        <h3 class="threads-head">Previous threads</h3>
        <ul v-if="threads.length" class="threads">
          <li v-for="thread in threads" :key="thread" class="thread">
            <span class="title" @click="loadThread(thread.session_id, thread.context)">{{ thread.chat_title }}</span>
            <b-btn
                variant="outline-secondary"
                size="sm"
                class="del-thread"
                @click="delThread(thread.session_id)"
              >
                <i class="fa fa-trash"></i>
            </b-btn>
            <span class="date">{{ getThreadDate(thread.timestamp) }}</span>
          </li>
        </ul>
        <ul v-else class="threads">
          <li class="thread">
            <span class="title" @click="newChat">Start New Chat</span>
          </li>
        </ul>
      </b-col>
      <b-col cols="9">
        <div v-if="!showResponsePanel && !showContextPanel && !showQueryPanel" class="empty-box">
          <div class="emptybox-button">
            <span>Hello from MyndSparX! &nbsp;&nbsp;&nbsp;</span>
            <img src="/images/sparks-on.png" alt="Mynd - Sparks" />
          </div>
          <b-btn variant="primary" @click="newChat" class="mt-4">
            <i class="fa fa-chart-area"></i> Start New Chat
          </b-btn>
        </div>
        <div v-show="showResponsePanel" class="response-box" id="response-box">
          <template v-if="messages.length">
            <div v-for="(message, n) in messages" :key="n" class="response-item">
              <div class="query">{{ message.query }}<br>
                <a href="#" @click="toggleDocspanel" class="ml-auto">{{ showDocspanel? "Close":"View" }}</a>&nbsp;
                <span>{{ message.docs? message.docs.title.length:'0' }} related documents</span>
              </div>
              <div v-show="showDocspanel" class="documents">
                <div class="documentslist">
                  <ul>
                    <li v-for="(doc, n) in message.docs.title" :key="n"><b-link @click="viewDocument(message.docs.id[n])">{{ n+1 }}: {{ doc }}</b-link></li>
                  </ul>
                </div>
              </div>
              <div class="response">
                <div class="avatar">
                  <img src="/images/favicon.png" />
                </div>
                <div class="res-text" v-html="message.response || '<span class=&quot;thinking&quot;>Thinking...</span>'"></div>
              </div>
            </div>
          </template>
          <div v-if="showInitials" class="response-item">
            <div v-show="query" class="query">{{ query }}<br>
              <template v-if="docs">
              <span>Mynd used {{ docs? docs.title.length:'0' }} documents to calculate the answer</span>&nbsp;
              <a href="#" @click="toggleDocspanel" class="ml-auto">{{ showDocspanel? "Close":"View Documents" }}</a>
              </template>
            </div>
            <div v-if="docs && showDocspanel" class="documents">
              <div v-show="showDocspanel" class="documentslist">
                <ul>
                  <li v-for="(doc, n) in docs.title" :key="n"><b-link @click="viewDocument(docs.id[n])">{{ n+1 }}: {{ doc }}</b-link></li>
                </ul>
              </div>
            </div>
            <div class="response">
              <div class="avatar">
                <img src="/images/favicon.png" />
              </div>
              <div id="chatbot-response" class="res-text"><span class="thinking">Thinking...</span></div>
            </div>
          </div>
        </div>
        <div v-if="showContextPanel" class="context-box">
          <b-form-group id="input-group-query" class="context" label-for="input-query">
              <b-form-textarea
                id="input-context"
                placeholder="Enter context...."
                v-model.trim="form.context"
                v-validate="{ max: 5000 }"
                data-vv-name="context"
              ></b-form-textarea>
              <b-form-textarea
                id="input-instruction"
                placeholder="Enter instruction or leave blank (Max 100 Chars)"
                v-model.trim="form.instruction"
                v-validate="{ max: 100 }"
                data-vv-name="instruction"
              ></b-form-textarea>
              <b-btn
                variant="primary"
                size="lg"
                @click="toggleContextpanel"
                >
                Save &amp; Close
              </b-btn>
          </b-form-group>
        </div>
        <div v-if="showHistoryPanel" class="context-box">
          <b-card title="Saved Chat History Found!" sub-title="please read carefully and proceed!">
            <b-card-text>
              We have found your previous Q&amp;A saved session. Will you like to restore it and continue or start a new one?
            </b-card-text>
            <b-link href="#" class="card-link" @click="restoreSavedHistory">Restore</b-link>
            <b-link href="#" class="card-link" @click="newChat">Start New</b-link>
          </b-card>
        </div>
        <div v-if="showQueryPanel" class="query-box">
          <h3>Ask anything about ({{currentModelName}})</h3>

          <b-form-group id="input-group-query" class="query" label-for="input-query">
            <b-form-input
                    id="input-query"
                    v-model.trim="form.query"
                    v-validate="{ required: true, max: 1000 }"
                    data-vv-name="query"
                    v-on:keyup.enter="submit"
            ></b-form-input>
            <b-btn
                variant="primary"
                size="lg"
                class="mr-2"
                @click="toggleContextpanel"
                >
                <i class="fa fa-sliders-h"></i>
            </b-btn>
            <b-btn
                variant="primary"
                size="lg"
                :disabled="!form.query || form.query === ''"
                @click="submit"
                >
                <i class="fa fa-angle-right"></i>
            </b-btn>
          </b-form-group>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Vue from "vue";
import store from "../../../store/store";
import { mapActions, mapGetters, mapState } from "vuex";
import VueMarkdown from 'vue-markdown';
import { startWriting } from "../../../helpers/TypeWriter";
import { EventBus } from "@/eventBus";

export default {
  name: "chatbot",
  components: {
    VueMarkdown
  },
  data() {
    return {
      form:{
        query: null,
        context: null,
        instruction: null
      },
      layout: 'full',
      threads: [],
      messages: [],
      threadSessionID: "",
      query: null,
      context: null,
      instruction: null,
      history: "no",
      savedHistory: null,
      stream: "",
      response: null,
      docs: null,
      restored: false,
      showConfirmNew: false,
      showConfirmDelete: false,
      showConfirmClear: false,
      showDocspanel: false,
      showResponsePanel: false,
      showContextPanel: false,
      showHistoryPanel: false,
      showQueryPanel: false,
      showInitials: false,
      useAnswerAsContext: "no",
      chatbotErrors: [
        "Invalid Input",
        "No relevant information found. Kindly specify your question!"
      ],
      writingInterval: null,
      scrollHeight: 0
    };
  },
  computed: {
    ...mapGetters([]),
    ...mapState({
      apiId: (state) => state.api.apiId,
      userid: (state) => state.auth.user._id,
      currentModelName: (state) => state.api.currentModelName,
      currentProjectName: (state) => state.api.currentProjectName,
      isConnected: (state) => state.chatbot.isConnected,
      socket: (state) => state.chatbot.socket,
      currentThread: (state) => state.chatbot.currentThread
    }),
  },
  watch: {
    socket:{
      handler: function (val) {
        if(val.message !== "stream_terminated" && typeof val.message !== "undefined"){
          const msg = this.stream;
          this.stream = msg.concat(val.message);
        }
        if(val.message === "stream_terminated"){
          this.response = this.stream;
        }
        if(typeof val.message === "object"){
          //console.log(val, "object");
          this.docs = val.message;
        }
        if(this.chatbotErrors.includes(val.message)){
          this.response = val.message;
        }
      },
      deep: true
    },
    response(val){
      if(val !== ""){
        this.restored? this.publishDirect():this.publish();
      }
    }
  },
  mounted() {
    if(this.currentThread){
      this.restored = true;
      this.docs = this.currentThread.docs;
      this.query = this.currentThread.query;
      this.context = this.currentThread.context;
      this.instruction = this.currentThread.instruction;
      this.form.context = this.context;
      this.form.instruction = this.instruction;
      this.response = this.currentThread.response;
      this.useAnswerAsContext = this.currentThread.useAnswerAsContext;
      this.setChatbotThread(null);
    }
    else{
      this.loadThreads({model_id : this.apiId}).then(res => {
        this.threads = res;
      });
    }
  },
  methods: {
    ...mapActions([
      "toggleChatBotState",
      "setChatbotStatus",
      "setChatbotMessage",
      "setChatbotThread",
      "resetChatbot",
      "resetChatbotHistory",
      "checkChatbotHistory",
      "loadThreads",
      "deleteThread",
      "getThreadMessages"
    ]),
    toggleExploreSidebar() {
      this.saveFilterSidebarState(!this.filterSidebarState);
    },
    startChat(user, session){
      this.$connect(process.env.VUE_APP_MYNDSPARK_URL+Vue.prototype.$globalSettings.api_endpoint+"/query_chatbot?user="+user+"&session_id="+session, {
        store: store,
        format: 'json',
        reconnection: true, // (Boolean) whether to reconnect automatically (false)
        reconnectionAttempts: 3, // (Number) number of reconnection attempts before giving up (Infinity),
        reconnectionDelay: 3000,
      })
    },
    loadThread(id, cntx = null){
      if(id !== ""){
        this.form.query = null;
        this.form.context = cntx;
        this.form.instruction = null;
        this.query = null;
        this.context = null;
        this.instruction = null;
        this.history = "no";
        this.useAnswerAsContext = "no";
        this.stream = "";
        this.response = null;
        this.docs = null;
        this.setChatbotMessage("");
        this.$disconnect();
        this.messages = [];
        this.showResponsePanel = true;
        this.showQueryPanel = true;
        this.getThreadMessages({model_id : this.apiId, session_id : id}).then(res => {
          let i = 0;
          while(i < res.length){
            this.messages.push({
              query: res[i+0],
              docs: {title: res[i+3], id: res[i+2]},
              response: res[i+1]
            })
            i += 4;
          }
        })
        this.startChat(this.userid, id);
        setTimeout(() => {
          let element = document.getElementById("response-box");
          element.scrollTop = element.scrollHeight;
        }, 500);
      }
    },
    delThread(id){
      this.deleteThread({model_id: this.apiId, session_id: id}).then(() => {
        this.loadThreads({model_id : this.apiId}).then(res => {
          this.threads = res;
          this.form.query = null;
          this.form.context = null;
          this.form.instruction = null;
          this.query = null;
          this.context = null;
          this.instruction = null;
          this.history = "no";
          this.useAnswerAsContext = "no";
          this.stream = "";
          this.response = null;
          this.docs = null;
          this.setChatbotMessage("");
          this.$disconnect();
          this.messages = [];
          this.showResponsePanel = false;
          this.showQueryPanel = false;
          this.$toasted.show("Thread deleted", {
            type: "success",
          });
        });
      })
    },
    async submit() {
      this.response = null;
      this.stream = "";
      this.docs = null;
      this.query = this.form.query;
      this.form.query = null;
      this.showInitials = true;
      //this.form.context = null;
      //this.setChatbotMessage("Please wait while we are working on your query...");
      this.$socket.sendObj({
        model_id: this.apiId,
        query: this.query,
        context: this.context,
        history: this.useAnswerAsContext,
        instruction: this.instruction || ""
      })
    },
    publish(){
      const app = document.getElementById('chatbot-response');
      this.updateScroll();
      //app.innerHTML(this.response);
      let tw = startWriting(app);
      tw
        .pauseFor(1000)
        .typeString(this.response)
        .pauseFor(300)
        //.deleteChars(10)
        //.typeString("<br /><br />")
        .callFunction(() => {
          clearInterval(this.writingInterval);
          tw.stop();
        })
        //.typeString(answer)
        //.pauseFor(1000)
        .start();
    },
    publishDirect(){
      const app = document.getElementById('chatbot-response');
      app.innerHTML = this.response;
    },
    newChat(){
      this.form.query = null;
      this.form.context = null;
      this.form.instruction = null;
      this.query = null;
      this.context = null;
      this.instruction = null;
      this.history = "no";
      this.useAnswerAsContext = "no";
      this.stream = "";
      this.response = null;
      this.docs = null;
      this.setChatbotMessage("");
      this.$disconnect();
      this.messages = [];
      //this.toggleConfirmNew();
      this.showResponsePanel = true;
      this.showQueryPanel = true;
      if(this.showHistoryPanel){
        this.resetChatbotHistory({model_id : this.apiId}).then(() => {
          this.showHistoryPanel = !this.showHistoryPanel;
        });
      }
      this.startChat(this.userid, "");
    },
    deleteIndexing(){
      if(this.showConfirmDelete){
        this.resetChatbot({model_id : this.apiId}).then(() => {
          this.$disconnect();
          this.setChatbotStatus(0);
          this.toggleChatBotState();
          this.$toasted.show("indexing cleared for selected model", {
            type: "success",
          });
        });
      }
      else{
        this.toggleConfirmDelete();
      }
    },
    toggleConfirmNew(){
      this.showConfirmNew = !this.showConfirmNew;
    },
    toggleConfirmDelete(){
      this.showConfirmDelete = !this.showConfirmDelete;
    },
    toggleConfirmClear(){
      this.showConfirmClear = !this.showConfirmClear;
    },
    toggleDocspanel(){
      this.showDocspanel = !this.showDocspanel;
    },
    toggleHistoryPanel(){
      this.showHistoryPanel = !this.showHistoryPanel;
    },
    toggleContextpanel(){
      this.context = this.form.context;
      this.instruction = this.form.instruction;
      this.showResponsePanel = !this.showResponsePanel;
      this.showContextPanel = !this.showContextPanel;
    },
    restoreSavedHistory(){
      this.query = this.savedHistory[this.savedHistory.length - 2];
      this.history = "yes";
      this.useAnswerAsContext = "yes";
      this.stream = "";
      this.response = this.savedHistory[this.savedHistory.length - 1];
      this.toggleHistoryPanel();
      this.publishDirect();
    },
    close() {
      this.setChatbotThread(null);
      this.docs = null;
      this.query = null;
      this.stream = "";
      this.response = null;
      this.restored = false;
      this.toggleChatBotState();
      this.setChatbotMessage("");
      this.$disconnect();
    },
    saveAndclose(){
      if(this.showConfirmClear){
        this.setChatbotThread(null);
        this.docs = null;
        this.query = null;
        this.stream = "";
        this.response = null;
        this.restored = false;
        this.toggleChatBotState();
        this.setChatbotMessage("");
        this.$disconnect();
      }
      else{
        this.toggleConfirmClear();
      }
    },
    getThreadDate(date){
      let days = this.$moment().diff(this.$moment(date), 'days');
      if(days === 0){
        return "Edited "+this.$moment().diff(this.$moment(date), 'hours')+" hours ago";
      }
      else{
        return "Edited "+days+" days ago";
      }
    },
    viewDocument(webkey) {
      this.close();
      this.$emit("toggleDocumentsPanel");
      EventBus.$emit("viewDocument", webkey);
    },
    updateScroll(inter = null){
      //this.scrollHeight = document.getElementById("response-box").scrollHeight;
      if(inter){
        clearInterval(this.writingInterval);
      }
      else{
        this.writingInterval = setInterval(() => {
          let element = document.getElementById("response-box");
          element.scrollTop = element.scrollHeight;
        }, 1000);
      }
    }
  },
};
</script>

<style scoped>
.thinking {
  animation: pulse 1.4s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.4;
  }
}
</style>
